module.exports = __webpack_public_path__ + "static/NodeStart-d606562aecd301b3241442da90b998b9.png";